import { useSnapshot } from "valtio";
import { useState, useEffect, useRef } from "react";
import uiState from "../data";
import { windowSizeState } from "../utils/windowSize";
import { AnimatePresence, motion } from "framer-motion";
import { isMobile } from "react-device-detect";
import { googleSheet } from "../utils/getSheet";

const Spa = ({ event }) => {
  const { visible } = useSnapshot(uiState[event]);
  const [scrollStatus, setScrollStatus] = useState(null);
  const [showLogoFilter, setShowLogoFilter] = useState(false);
  const [currentScrollY, setCurrentScrollY] = useState(0);
  const { vh } = useSnapshot(windowSizeState);
  const { mobileMode } = useSnapshot(windowSizeState);
  const phRef1 = useRef();
  const phRef2 = useRef();
  const phRef3 = useRef();
  const phRef4 = useRef();
  const data = googleSheet["homepage"].filter((el) => {
    return el.part === "factory_spa";
  })[0];

  const goFactoryEntrance = () => {
    uiState.factoryEntrance.visible = true;
    uiState.factorySpa.visible = false;
  };

  const floatVariants = {
    show: {
      y: [5, -5, 5],
      transition: {
        duration: 2.2,
        repeat: Infinity,
        times: [0, 0.6, 1],
      },
    },
    hide: {
      y: [0],
    },
  };

  useEffect(() => {
    // 第一頁scroll字樣的動畫
    if (currentScrollY < 0.4 * vh) {
      setScrollStatus("leavePage2");
    } else {
      setScrollStatus("enterPage2");
    }
    // logo底圖出現的計算
    if (currentScrollY > 120) {
      setShowLogoFilter(true);
    } else {
      setShowLogoFilter(false);
    }
  }, [currentScrollY, vh]);

  useEffect(() => {
    const handleScroll = () => {
      setCurrentScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {/* 行動版 */}
      <AnimatePresence>
        {visible && mobileMode && (
          <motion.div
            className="absolute top-0 left-0 z-[101] w-full"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
          >
            <img
              src="../startImages/icon/back.png"
              alt="返回鍵"
              className={`fixed top-[70px]  left-[5%]  w-[110px] portraitBigPh:w-[70px] portraitBigPh:top-[50px] landscapePhone:w-[70px] landscapePhone:top-[50px] landscapePhone:left-[10%] cursor-pointer z-30  `}
              onClick={() => {
                uiState.enterPage.visible = true;
                uiState[event].visible = false;
              }}
            />
            {scrollStatus === "enterPage2" && (
              <motion.div
                className="fixed bottom-[50px] left-[5%] box-border  h-[40px] flex justify-start  z-10 landscapePhone:left-[10%]"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
              >
                <motion.button
                  className="Trajan border-mainOrange-100 px-6 portraitPh:px-5 landscapePhone:px-5 h-full  portraitPh:py-[5px] landscapePhone:py-[5px] text-[16px] portraitPh:text-[14px] rounded-full shadow-lg  border-2 bg-mainOrange-100 text-white cursor-pointer"
                  onClick={goFactoryEntrance}
                  variants={floatVariants}
                  initial="hide"
                  animate="show"
                >
                  {data.en_btn1}
                </motion.button>
              </motion.div>
            )}

            {/* logo下的色塊 */}
            <AnimatePresence>
              {showLogoFilter && (
                <motion.div
                  className="fixed top-0 left-0 h-[220px] portraitBigPh:h-[200px] w-full z-20 bg-gradient-to-b from-white to-transparent pointer-events-none"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.5 }}
                ></motion.div>
              )}
            </AnimatePresence>

            <div className="fixed top-0 left-1/2 -translate-x-1/2 h-full flex flex-col justify-between z-20">
              <div className="flex flex-col items-center">
                <div>
                  <img
                    src="../startImages/logo/color.png"
                    alt="logo 彩色部分"
                    className="w-[50px] portraitBigPh:w-[30px] landscapePhone:w-[30px]"
                  />
                </div>
                <div>
                  <img
                    src="../startImages/logo/big_logo.png"
                    alt="黑色 logo"
                    className="w-[100px] portraitBigPh:w-[75px] landscapePhone:w-[75px]"
                  />
                </div>
              </div>
            </div>

            <div className="w-full overflow-hidden factorySpaBgPh">
              {/* 第一頁 */}
              <div className="w-full   flex flex-col items-center">
                <div className="relative w-[700px] mt-[30px] portraitBigPh:w-[390px] portraitBigPh:mt-[40px] landscapePhone:w-[390px] landscapePhone:-mr-[100px] ">
                  <div className={`w-full translate-x-[40%]`}>
                    <img
                      src="../startImages/pic/factory_tour.png"
                      alt="彩色圖片"
                      className="w-full object-contain"
                    />
                  </div>
                  <div
                    className="w-full h-[5%] absolute top-1/2 left-0  translate-y-[50%] "
                    id="page1"
                    ref={phRef1}
                  ></div>
                </div>

                <div className=" w-[90%] portraitBigPh:-mt-[10px]">
                  <div>
                    <div className="Trajan text-[24px] portraitPh:text-[18px]">
                      <p>{data.en_title1}</p>
                    </div>
                    <div className="mt-3">
                      <p className="text-[16px] portraitPh:text-[15px] jf">
                        {data.en_content1}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="jf  text-scrollText-100 text-[17px] flex overflow-hidden  mt-[16px] portraitBigPh:mt-[20px]">
                  <motion.div
                    className="w-[1px] h-[50px] bg-scrollText-100 mr-4"
                    animate={{
                      y: scrollStatus === "enterPage2" ? "50px" : "0px",
                    }}
                    transition={{ duration: 0.5 }}
                  ></motion.div>
                  <motion.p
                    className="leading-[50px]"
                    animate={{ opacity: scrollStatus === "enterPage2" ? 0 : 1 }}
                    transition={{ duration: 0.5 }}
                  >
                    <p>{data.scrollTip}</p>
                  </motion.p>
                </div>
              </div>

              {/* 第二頁 */}
              <div className="w-full overflow-hidden  flex flex-col items-center">
                <div className="w-[700px] mt-[8%] relative portraitBigPh:w-[390px] portraitBigPh:mt-0 landscapePhone:w-[390px] landscapePhone:-mr-[100px] ">
                  <div className={`w-full -translate-x-[40%]`}>
                    <img
                      src="../startImages/pic/Art_and_Science.png"
                      alt="彩色圖片"
                      className="w-full object-contain"
                    />
                  </div>
                  <div
                    className="w-full h-[5%] absolute top-1/2 left-0 -translate-y-1/2 "
                    id="page2"
                    ref={phRef2}
                  ></div>
                </div>

                <div className=" w-[90%] portraitBigPh:-mt-[10px]">
                  <div>
                    <div className="Trajan text-[24px] portraitPh:text-[18px] text-end">
                      <p>{data.en_title2}</p>
                    </div>
                    <div className="mt-3">
                      <p className="text-[16px] portraitPh:text-[15px] jf">
                        {data.en_content2}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 第三頁 */}
              <div className="w-full overflow-hidden flex flex-col items-center">
                <div
                  className={` w-[700px] mt-[8%] relative portraitBigPh:w-[390px] portraitBigPh:mt-[50px] landscapePhone:w-[390px] landscapePhone:-mr-[100px]`}
                >
                  <div className={` w-full translate-x-[40%] `}>
                    <img
                      src="../startImages/pic/Precision_and_Consistency.png"
                      alt="彩色圖片"
                      className="w-full object-contain"
                    />
                  </div>
                  <div
                    className="w-full h-[5%] absolute top-1/2 left-0 -translate-y-1/2 "
                    id="page3"
                    ref={phRef3}
                  ></div>
                </div>
                <div className=" w-[90%]  ">
                  <div>
                    <div className="Trajan text-[24px] portraitPh:text-[18px]">
                      <p>{data.en_title3}</p>
                    </div>
                    <div className="mt-3">
                      <p className="text-[16px] portraitPh:text-[15px] jf">
                        {data.en_content3}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 第四頁 */}

              <div className="w-full overflow-hidden flex flex-col items-center ">
                <div
                  className={` w-[700px] mt-[8%] relative portraitBigPh:w-[390px] portraitBigPh:mt-[50px] landscapePhone:w-[390px] landscapePhone:-mr-[100px]`}
                >
                  <div className={` w-full -translate-x-[40%] `}>
                    <img
                      src="../startImages/pic/the_human_element.png"
                      alt="彩色圖片"
                      className="w-full object-contain"
                    />
                  </div>
                  <div
                    className="w-full h-[5%] absolute bottom-1/2 left-0  -translate-y-1/2 "
                    id="page4"
                    ref={phRef4}
                  ></div>
                </div>
                <div className=" w-[90%] mb-[25%] portraitBigPh:mt-0 portraitBigPh:mb-[30%] ">
                  <div>
                    <div className="Trajan text-[24px] portraitPh:text-[18px] text-end">
                      <p>{data.en_title4}</p>
                    </div>
                    <div className="mt-3">
                      <p className="text-[16px] portraitPh:text-[15px] jf">
                        {data.en_content4}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* 電腦版 */}
      <AnimatePresence>
        {visible && !mobileMode && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
          >
            <img
              src="../startImages/icon/back.png"
              alt="返回鍵"
              className={`fixed top-[80px] portraitPad:top-[70px]  left-[160px] portraitPad:left-[10%] smallLaptop:left-[8%] landscapePad:left-[8%] authPCHeight:left-[10%]  w-[110px] portraitBigPh:w-[70px] portraitBigPh:top-[50px] landscapePhone:w-[70px] landscapePhone:top-[50px] landscapePhone:left-[10%] cursor-pointer z-30 ${
                !mobileMode && "opacity-70"
              } hover:opacity-100 `}
              onClick={() => {
                uiState.enterPage.visible = true;
                uiState[event].visible = false;
              }}
            />
            {scrollStatus === "enterPage2" && (
              <motion.div
                className="fixed bottom-[80px] left-[160px] box-border  h-[40px] flex justify-start smallLaptop:left-[8%] landscapePad:left-[8%] portraitPh:h-[40px] landscapePhone:h-[40px] mt-4 z-20"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
              >
                <motion.button
                  className={`Trajan border-mainOrange-100 px-6 portraitPh:px-5 landscapePhone:px-5 h-full  portraitPh:py-[5px] landscapePhone:py-[5px] text-[16px] portraitPh:text-[14px] rounded-full shadow-lg  border-2  bg-mainOrange-100 text-white cursor-pointer ${
                    !isMobile && "hover:scale-[1.025]"
                  }`}
                  onClick={goFactoryEntrance}
                  variants={floatVariants}
                  initial="hide"
                  animate="show"
                >
                  {data.en_btn1}
                </motion.button>
              </motion.div>
            )}

            {/* logo下的色塊 */}
            <AnimatePresence>
              {showLogoFilter && (
                <motion.div
                  className="fixed top-0 left-0 h-[230px] w-full bg-gradient-to-b from-white to-transparent z-20 pointer-events-none"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.5 }}
                ></motion.div>
              )}
            </AnimatePresence>

            <div className="fixed top-0 left-1/2 -translate-x-1/2 h-full flex flex-col justify-between z-20">
              <div className="flex flex-col items-center">
                <div>
                  <img
                    src="../startImages/logo/color.png"
                    alt="logo 彩色部分"
                    className="w-[50px]"
                  />
                </div>
                <div>
                  <img
                    src="../startImages/logo/big_logo.png"
                    alt="黑色 logo"
                    className="w-[100px]"
                  />
                </div>
              </div>
            </div>

            <div className="w-full overflow-hidden factorySpaBgPc ">
              {/* 第一頁 */}
              <div id="page1" className="screen-setting relative ">
                <div className=" w-[35%] absolute top-[55%] -translate-y-1/2 left-[160px] flex flex-col justify-between items-start smallLaptop:left-[8%] landscapePad:left-[8%]">
                  <div>
                    <div className="Trajan text-[34px] smallLaptop:text-[24px] landscapePad:text-[24px]">
                      <p>{data.en_title1}</p>
                    </div>
                    <div className="mt-4">
                      <p className="text-[17px] smallLaptop:text-[16px] landscapePad:text-[16px] jf">
                        {data.en_content1}
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  className={`absolute top-1/2 right-0 -translate-y-1/2 h-[130%] w-[65%] translate-x-[28%] landscapePad:scale-[1.3] landscapePad:translate-x-[40%]   z-10  `}
                >
                  <img
                    src="../startImages/pic/factory_tour.png"
                    alt="彩色圖片"
                    className="h-full object-contain "
                  />
                </div>

                <div className="jf absolute bottom-[10%] left-1/2 -translate-x-1/2 text-scrollText-100 text-[17px] flex overflow-hidden landscapePad:bottom-[3%] ">
                  <motion.div
                    className="w-[1px] h-[50px] bg-scrollText-100 mr-4"
                    animate={{
                      y: scrollStatus === "enterPage2" ? "50px" : "0px",
                    }}
                    transition={{ duration: 0.5 }}
                  ></motion.div>
                  <motion.p
                    className="leading-[50px]"
                    animate={{ opacity: scrollStatus === "enterPage2" ? 0 : 1 }}
                    transition={{ duration: 0.5 }}
                  >
                    <p>{data.scrollTip}</p>
                  </motion.p>
                </div>
              </div>

              {/* 第二頁 */}
              <div id="page2" className="screen-setting relative mt-[10%]">
                <div className=" w-[35%] absolute top-[50%]  -translate-y-1/2 right-[160px] flex flex-col justify-between items-start smallLaptop:right-[8%] landscapePad:right-[8%]">
                  <div>
                    <div className="Trajan text-[34px] smallLaptop:text-[24px] landscapePad:text-[24px]">
                      <p>{data.en_title2}</p>
                    </div>
                    <div className="mt-4">
                      <p className="text-[17px] smallLaptop:text-[16px] landscapePad:text-[16px] jf">
                        {data.en_content2}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className={`absolute top-1/2 left-0 h-[130%] w-[65%] -translate-y-1/2 -translate-x-[28%]  z-10 landscapePad:scale-[1.3] landscapePad:-translate-x-[40%] `}
                >
                  <img
                    src="../startImages/pic/Art_and_Science.png"
                    alt="彩色圖片"
                    className="h-full object-contain"
                  />
                </div>
              </div>

              {/* 第三頁 */}
              <div id="page3" className="screen-setting relative mt-[10%] ">
                <div className="w-[40%] absolute top-[50%]  -translate-y-1/2 left-[160px] flex flex-col justify-between items-start smallLaptop:left-[8%] landscapePad:left-[8%]">
                  <div>
                    <div className="Trajan text-[34px] smallLaptop:text-[24px] landscapePad:text-[24px]">
                      <p>{data.en_title3}</p>
                    </div>
                    <div className="mt-4">
                      <p className="text-[17px] smallLaptop:text-[16px] landscapePad:text-[16px] jf w-[90%]">
                        {data.en_content3}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className={`absolute top-1/2 -translate-y-1/2 right-0 translate-x-[28%] h-[130%] w-[65%] z-10 landscapePad:scale-[1.3] landscapePad:translate-x-[40%]`}
                >
                  <img
                    src="../startImages/pic/Precision_and_Consistency.png"
                    alt="彩色圖片"
                    className="h-full object-contain"
                  />
                </div>
              </div>

              {/* 第四頁 */}
              <div id="page4" className="screen-setting relative mt-[10%] ">
                <div className="w-[35%] absolute top-[50%]  -translate-y-1/2 right-[160px] flex flex-col justify-between items-start smallLaptop:right-[8%] landscapePad:right-[8%]">
                  <div>
                    <div className="Trajan text-[34px] smallLaptop:text-[24px] landscapePad:text-[24px]">
                      <p>{data.en_title4}</p>
                    </div>
                    <div className="mt-4">
                      <p className="text-[17px] smallLaptop:text-[16px] landscapePad:text-[16px] jf">
                        {data.en_content4}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className={`absolute top-1/2 left-0 h-[130%] w-[65%] -translate-y-1/2 -translate-x-[28%] z-10 landscapePad:scale-[1.3] landscapePad:-translate-x-[40%]`}
                >
                  <img
                    src="../startImages/pic/the_human_element.png"
                    alt="彩色圖片"
                    className="h-full object-contain"
                  />
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Spa;
